import React from "react";
import { Field, ErrorMessage } from "formik";
// import { ChevronDown } from "lucide-react";
import { IoChevronDownSharp } from "react-icons/io5";

const FormField = ({
  label,
  name,
  type = "text",
  placeholder = "Select",
  required = false,
  options = [],
  radioOptions = [],
  disabled,
}) => {
  return (
    <div className="mb-6">
      <label
        htmlFor={name}
        className="block text-[#000000] text-[12px] font-[400] mb-2"
      >
        {label} {required && <span className="text-blue-600">*</span>}
      </label>

      {type === "select" ? (
        <div className="relative">
          <Field
            as="select"
            name={name}
            id={name}
            disabled={disabled}
            className="w-full h-[35px] border border-gray-300 rounded-md py-[10px] px-[15px] text-grey-200 text-xs appearance-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent placeholder:text-red-500"
          >
            <option value="" className="text-[2px] text-red-500">
              {placeholder}
            </option>
            {options.map((option) => (
              <option key={option?.value} value={option?.value}>
                {option?.label}
              </option>
            ))}
          </Field>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <IoChevronDownSharp size={12} />
          </div>
        </div>
      ) : type === "radio" ? (
        <div className="flex items-center gap-4">
          {radioOptions.map((opt) => (
            <div key={opt.id} className="flex flex-row items-center">
              <Field
                type={type}
                name={name}
                id={opt.id}
                value={opt.id}
                disabled={disabled}
                className="mr-1 h-[35px] py-[10px] px-[15px]  "
              />

              <label className="text-xs" htmlFor={opt.id}>
                {opt.name}
              </label>
            </div>
          ))}
        </div>
      ) : (
        <Field
          type={type}
          id={name}
          name={name}
          placeholder={placeholder}
          min={ "2025-06-01"}
          max={new Date().toISOString().split("T")[0]}
          className="w-full h-[35px] border border-gray-300 rounded-md py-[10px] px-[15px] text-grey-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-xs  placeholder:text-xs"
        />
      )}
      <ErrorMessage
        name={name}
        component="div"
        className="text-red-500 text-xs mt-1"
      />
    </div>
  );
};

export default FormField;
